const MaggieMay = [
	'[Verse 1]',
	'Wake up, Maggie, I think I got some-thing to say to you:',
	"It's late September and I really should be back at school.",
	"I know I keep you amused, but I feel I'm being used.",
	'',
	'[CHORUS]',
	"Oh, Maggie, I couldn't have tried any more.",
	'You lured me away from home, just to save you from being alone.',
	"You stole my heart and that's what really hurts.",
	'',
	'[VERSE 2]',
	"The morning sun, when it's in your face really shows your age.",
	"But that don't worry me none; in my eyes you're everything.",
	"I laughed at all of your jokes, my love you didn't need to coax,",
	'',
	'[CHORUS]',
	"Oh, Maggie I couldn't have tried any more.",
	'You lured me away from home, just to save you from being alone.',
	"You stole my soul that's a pain I can do without.",
	'',
	'[VERSE 3]',
	'All I need was a friend to lend a guiding hand.',
	'But you turned into a lover and Mother what a lover your wore me out.',
	'All you did was wreck my bed, and in the morning kick me in the head,',
	'',
	'[CHORUS]',
	"Oh, Maggie I couldn't have tried any more.",
	"You lured me away from home, 'cause you did'nt want to be alone.",
	"You stole my heart I couldn't leave you if I tried.",
	'',
	'[VERSE 4]',
	'I suppose I could collect my books and get back to school.',
	"Or steal my daddy's cue and make a living out of playing pool.",
	'Or find myself a rock and roll band that needs a helping hand,',
	'',
	"Oh, Maggie, I wish I'd never seen your face.",
	'You made a first class fool out of me,',
	"but I'm as blind as a fool can be.",
	'You stole my heart, but I love you anyway.',
	'Maggie, I wish I never seen your face.',
	"I'll get on back home one of these days.",
];

export default MaggieMay;
